import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ConfirmDeleteDialog from "../../shared/ConfirmDeleteDialog";

/**
 * プロジェクト・求人カード右上のメニュー（編集／削除）
 * @param {number|string} itemId - 対象ID（project.id, job.id など）
 * @param {"project"|"job"} type - エンティティ種別
 */
const IndexMenu = ({ itemId, type = "project" }) => {
  const navigate = useNavigate();

  // URLや遷移先はtypeで切替
  const apiUrl =
    type === "job" ? `/company/jobs/${itemId}` : `/company/projects/${itemId}`;
  const listUrl = type === "job" ? "/company/jobs" : "/company/projects";
  const flashMessage =
    type === "job" ? "求人を削除しました。" : "プロジェクトを削除しました。";
  const editUrl =
    type === "job"
      ? `/company/jobs/${itemId}/edit`
      : `/company/projects/${itemId}/edit`;

  // メニューボタン（縦三点）のアンカー要素
  const [anchorEl, setAnchorEl] = useState(null);

  // 削除確認ダイアログの表示状態
  const [showDialog, setShowDialog] = useState(false);

  // メニューが開いているかどうか
  const open = Boolean(anchorEl);

  // メニューを開く（クリックした要素を基準に）
  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);

  // メニューを閉じる
  const handleCloseMenu = () => setAnchorEl(null);

  // 「削除する」クリック時：ダイアログを開き、メニューは閉じる
  const handleOpenDialog = () => {
    setShowDialog(true);
    handleCloseMenu();
  };

  const [isDeleting, setIsDeleting] = useState(false);

  // ダイアログのキャンセルまたは外側クリックで閉じる
  const handleCloseDialog = () => {
    if (isDeleting) return; // 削除中は閉じさせない
    setShowDialog(false);
  };

  /**
   * 「削除」を確定したときの処理
   * DELETE リクエストを送り、完了後にページをリロード
   */
  const handleConfirmDelete = () => {
    if (isDeleting) return; // 2重発火防止
    setIsDeleting(true);
    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]'
    )?.content;

    fetch(apiUrl, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
    }).then((res) => {
      if (res.ok) {
        setIsDeleting(false);
        setShowDialog(false);
        navigate(listUrl, { state: { flashMessage } });
      } else {
        alert("削除に失敗しました");
      }
    });
  };

  return (
    <>
      {/* 縦三点ボタン */}
      <IconButton
        onClick={(e) => {
          e.stopPropagation(); // 親のCardクリック伝播を防ぐ
          e.preventDefault(); // デフォルト遷移（Link遷移）を防ぐ
          handleOpenMenu(e); // メニュー（編集／削除）を開く処理
        }}
        size="small"
        sx={{ p: 0.5 }}
      >
        <MoreHorizIcon />
      </IconButton>

      {/* メニュー（編集・削除） */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={(event, reason) => {
          // メニューが閉じられる際に、Cardへの伝播を止める
          if (event?.stopPropagation) event.stopPropagation();
          handleCloseMenu();
        }}
      >
        {/* 編集リンク：href指定で通常遷移 */}
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            navigate(editUrl);
          }}
        >
          編集する
        </MenuItem>

        {/* 削除ボタン：確認ダイアログを開く */}
        <MenuItem
          onClick={(e) => {
            e.stopPropagation(); // 親のCardクリック伝播を防ぐ
            e.preventDefault(); // デフォルト遷移（Link遷移）を防ぐ
            handleOpenDialog(); // 削除確認ダイアログを開く
          }}
          sx={{ color: "red" }}
        >
          削除する
        </MenuItem>
      </Menu>

      {/* 削除確認ダイアログ */}
      <ConfirmDeleteDialog
        open={showDialog}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default IndexMenu;
